import { DatePipe } from '@angular/common';
import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import {
  CalculatorAutosDTO,
  DigitalIdDTO,
  DigitalIdResponseDTO,
  StatesFieldsFrontDTO,
} from '@app/requests/model/requests-model';
import { FormBuilder, FormControl, FormGroup, ValidatorFn, Validators } from '@angular/forms';
import { RequestsSaveSendStore } from '@app/requests/requests-save-send-service/requests-save-send.store';
import { forkJoin } from 'rxjs';
import { MatDatepicker } from '@angular/material/datepicker';
import {
  FINANCIAL_PRODUCT_AUTO,
  REQUEST_DATA,
  POINT_OF_SALE,
  REQUEST_MODE_EDIT,
  REQUEST_MODE_NEW,
  REQUEST_MODE_VIEW,
  PENDIENTES_DE_DATOS,
  VEHICLE_USED,
} from '@app/@core/constants/requests.constants';

import * as _moment from 'moment';

import { Moment } from 'moment';
import { CombosStore } from '@app/requests/combos-service/combos.store';
import { CredentialsService } from '@app/login';
import { RequestAutosStore } from './request-data-autos.store';
import {
  ComercialProductResponseDTO,
  CommonDataDTO,
  TariffDTO,
  TypeVehicleReturnDTO,
  VehicleTypeFuel,
  VendorComboDTO,
  VersionAutoDTO,
} from '@app/requests/model/combos-model';
import { CustomValidatorsService } from '@app/@shared/custom-validators/custom-validators.service';
import { TranslateService } from '@ngx-translate/core';
import { finalize } from 'rxjs/operators';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { DatepickerUtilsService } from '@app/@shared/services/utils/datepicker-utils.service';
import { LOCALE_ES } from '@app/@core/constants/common.constants';
import { RequestsGetDataApi } from '@app/requests/requests-get-data-service/requests-get-data-api.service';

const moment = _moment;

@UntilDestroy()
@Component({
  selector: 'scf-request-data-autos',
  templateUrl: './request-data-autos.component.html',
  styleUrls: ['./request-data-autos.component.scss'],
})
export class RequestDataAutosComponent implements OnInit, OnChanges {
  @Input() public establishment: string;
  @Input() public isModeEdit: boolean;
  @Input() state: CommonDataDTO;
  @Input() public expirationMonth: string = '';
  @Input() public mode: string;
  @Input() public isEditAutos: boolean;
  @Input() public request: any = null;
  @Input() public operative: string = '';
  @Output() public changeContinueStatus = new EventEmitter<any>();
  @Output() public sendDataFinance = new EventEmitter<any>();
  @Output() public isFinishedLoading = new EventEmitter<any>();
  @Input() public vendor: VendorComboDTO;
  @Output() public changeValue = new EventEmitter<boolean>(false);

  public requestDataAutosForm: FormGroup;
  expirationDateList: CommonDataDTO[] = [];
  commercialProductList: CommonDataDTO[] = [];
  tariffsList: TariffDTO[] = [];
  typeVehicleList: TypeVehicleReturnDTO[] = [];
  brandList: CommonDataDTO[] = [];
  modelList: CommonDataDTO[] = [];
  versionList: VersionAutoDTO[] = [];
  formPaymentList: CommonDataDTO[] = [];
  importeMaxVideoSelfing: number;
  fuelTypeList: CommonDataDTO[] = [];

  currentDate: Date = new Date();
  minAntYearDate: Date = new Date('1/1/1900');

  reference: number;

  public isDisabled = true;
  private isCalculator: boolean;
  carRegistrationIsOptional: boolean = true;
  numRackIsOptional: boolean = true;
  public videoSelfingIDInit: string = '';
  public firstloadEdit: boolean = true;

  //Validation need to have the same ref than the one added for removing
  private validatorAntCar: ValidatorFn;

  //Loading
  private isExpirationDaysLoading: boolean = true;
  private isProductVehicleLoading: boolean = true;
  private isTariffLoading: boolean = true;
  private isFormPaymentLoading: boolean = false;
  private isBrandLoading: boolean = true;
  private isModelLoading: boolean = true;
  private isVersionLoading: boolean = true;

  //PE_725 Fenix
  fieldsDisabled: StatesFieldsFrontDTO[];

  constructor(
    private formBuilder: FormBuilder,
    private requestStore: RequestsSaveSendStore,
    private combosAutosStore: RequestAutosStore,
    private credentials: CredentialsService,
    private datePipe: DatePipe,
    private combosStore: CombosStore,
    private customValidators: CustomValidatorsService,
    private translateService: TranslateService,
    private datepickerUtils: DatepickerUtilsService,
    private requestsGetDataApi: RequestsGetDataApi
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.establishment) {
      this.reset();
      this.onEstablishmentSelection();
    }

    if (!changes.expirationMonth?.isFirstChange()) {
      if (changes.expirationMonth?.currentValue) {
        this.requestDataAutosForm.controls.firstMonth.setValue(
          this.translateService.instant(changes.expirationMonth.currentValue)
        );
      }
    }
  }

  ngOnInit(): void {
    this.requestDataAutosForm = this.formBuilder.group(
      {
        commercialProduct: ['', Validators.required],
        vehicleType: ['', Validators.required],
        model: [''],
        brand: [''],
        version: [''],
        fuelType: [''],
        numRack: ['', this.customValidators.isCarRackValid],
        antCar: ['', Validators.required],
        carRegistration: ['', this.customValidators.isCarRegistrationValid],
        priceVehicle: ['', [Validators.required]],
        requestedAmount: ['', Validators.required],
        start: [{ value: '', disabled: true }],
        term: ['', Validators.required],
        expirationDay: ['', Validators.required],
        firstMonth: [{ value: '', disabled: true }],
        tariffs: ['', Validators.required],
        formPayment: ['', Validators.required],
        quota: [''],
        insurance: [''],
      },
      {
        updateOn: 'change',
        validators: [this.customValidators.isRequestedAmountAutosValid()],
      }
    );

    this.translateService.currentLang === LOCALE_ES ? this.datepickerUtils.spanish() : this.datepickerUtils.catalan();
    this.translateService.onLangChange
      .pipe(untilDestroyed(this))
      .subscribe((event) =>
        event.lang === LOCALE_ES ? this.datepickerUtils.spanish() : this.datepickerUtils.catalan()
      );

    this.requestDataAutosForm.statusChanges.subscribe(() => {
      if (this.requestDataAutosForm) {
        this.isDisabled = this.requestDataAutosForm.invalid;
        this.changeContinueStatus.emit({ form: <FormGroup>this.requestDataAutosForm, id: REQUEST_DATA });
      }
    });

    this.getExpirationDays();

    if (this.mode) {
      const requiredNumRackCarRegistration = JSON.parse(localStorage.getItem('requiredNumRackCarRegistration'));

      if (this.requestDataAutosForm) {
        this.requestDataAutosForm.controls.model.addValidators(Validators.required);
        this.requestDataAutosForm.controls.brand.addValidators(Validators.required);
        this.requestDataAutosForm.controls.version.addValidators(Validators.required);
      }
      if (this.mode === REQUEST_MODE_VIEW) {
        if (this.state.id !== PENDIENTES_DE_DATOS) {
          this.requestDataAutosForm.disable();
        }
        this.setValuesToForm();

        if (this.isEditAutos) {
          this.calculate();
        }

        if (requiredNumRackCarRegistration) {
          this.requestDataAutosForm.removeControl('numRack');
          this.requestDataAutosForm.addControl(
            'numRack',
            new FormControl({ value: this.request.numRack, disabled: false }, [
              Validators.required,
              this.customValidators.isCarRackValid,
            ])
          );
          this.numRackIsOptional = false;
        } else {
          this.requestDataAutosForm.removeControl('numRack');
          this.requestDataAutosForm.addControl(
            'numRack',
            new FormControl({ value: this.request.numRack, disabled: false }, [this.customValidators.isCarRackValid])
          );
          this.numRackIsOptional = true;
        }

        if (this.request.typeVehicle !== 'TU00' && requiredNumRackCarRegistration) {
          this.requestDataAutosForm.removeControl('carRegistration');
          this.requestDataAutosForm.addControl(
            'carRegistration',
            this.carRegistrationFormControl(this.request.vehicleStatus)
          );
          this.carRegistrationIsOptional = false;
        } else {
          this.requestDataAutosForm.removeControl('carRegistration');
          this.requestDataAutosForm.addControl(
            'carRegistration',
            new FormControl({ value: this.request.carRegistration, disabled: false }, [
              this.customValidators.isCarRegistrationValid,
            ])
          );
          this.carRegistrationIsOptional = true;
        }
      } else if (this.mode === REQUEST_MODE_EDIT) {
        if (requiredNumRackCarRegistration) {
          this.requestDataAutosForm.removeControl('numRack');
          this.requestDataAutosForm.addControl(
            'numRack',
            new FormControl({ value: this.request.numRack, disabled: false }, [
              Validators.required,
              this.customValidators.isCarRackValid,
            ])
          );
          this.numRackIsOptional = false;
        } else {
          this.requestDataAutosForm.removeControl('numRack');
          this.requestDataAutosForm.addControl(
            'numRack',
            new FormControl({ value: this.request.numRack, disabled: false }, [this.customValidators.isCarRackValid])
          );
          this.numRackIsOptional = true;
        }

        if (this.request.typeVehicle !== 'TU00' && requiredNumRackCarRegistration) {
          this.requestDataAutosForm.removeControl('carRegistration');
          this.requestDataAutosForm.addControl(
            'carRegistration',
            this.carRegistrationFormControl(this.request.vehicleStatus)
          );
          this.carRegistrationIsOptional = false;
        } else {
          this.requestDataAutosForm.removeControl('carRegistration');
          this.requestDataAutosForm.addControl(
            'carRegistration',
            new FormControl({ value: this.request.carRegistration, disabled: false }, [
              this.customValidators.isCarRegistrationValid,
            ])
          );
          this.carRegistrationIsOptional = true;
        }

        this.setValuesToForm();
        this.calculate();
      } else {
        //New Mode
        this.requestStore.isCalculatorData$.subscribe((data) => {
          this.isCalculator = data;
        });

        if (this.isCalculator) {
          this.loadCombosFromCalculator();
        } else {
          this.isBrandLoading = false;
          this.isModelLoading = false;
          this.isVersionLoading = false;
          this.isTariffLoading = false;
          this.requestStore.setFormularioAutos(this.requestDataAutosForm, REQUEST_DATA);
        }
      }
    } else {
      this.isBrandLoading = false;
      this.isModelLoading = false;
      this.isVersionLoading = false;
      this.isTariffLoading = false;
    }

    this.requestStore.importeMaxVideoSelfing$.subscribe((value) => {
      if (value) {
        this.importeMaxVideoSelfing = parseInt(value);
      }
    });

    this.changeLoadingState();
  }

  onEstablishmentSelection() {
    this.commercialProductList = [];
    this.typeVehicleList = [];
    if (this.establishment) {
      this.isProductVehicleLoading = true;
      this.changeLoadingState();
      forkJoin([
        this.combosStore.loadCommercialProductForCombos(this.establishment, ''),
        this.combosAutosStore.loadTypeVehicle(this.establishment),
      ])
        .pipe(
          finalize(() => {
            this.isProductVehicleLoading = false;
            this.changeLoadingState();
          })
        )
        .subscribe(
          (respuestaFork: any) => {
            this.commercialProductList = this.combosStore.ComercialProductResponseToCommonData(respuestaFork[0]);
            this.typeVehicleList = respuestaFork[1];
            //se pasan a mayúscula
            this.typeVehicleList.forEach((value) => {
              value.sector = value.sector?.toUpperCase();
            });
            if (this.mode === REQUEST_MODE_EDIT && this.request) {
              this.setValuesToForm();
            } else if (!this.requestDataAutosForm.controls.commercialProduct.value) {
              this.requestDataAutosForm.controls.commercialProduct.setValue(this.commercialProductList[0].id);
            }

            // Search Form Payment.
            this.getFormPayment();
            //}

            if (this.typeVehicleList.length === 1) {
              this.requestDataAutosForm.controls.vehicleType.setValue(this.typeVehicleList[0].sector);
            }

            if (this.isModeDifferentFromNew()) {
              this.requestDataAutosForm.controls.commercialProduct.setValue(this.request.commercialProduct);
              this.requestDataAutosForm.controls.vehicleType.setValue(this.request.typeVehicle);
              this.getBrand();
              this.getModel();
              this.getVersion();
              this.getFuelType();
              this.getTariffs();
              this.getFormPayment();
              this.calculate();
            }
          },
          (error) => {
            console.error(error);
          },
          () => {
            this.isProductVehicleLoading = false;
            this.changeLoadingState();
          }
        );
    } else {
      // NOT ESTABLISHMENT SELECTED
      this.isProductVehicleLoading = false;
      this.changeLoadingState();
    }
  }

  private getExpirationDays() {
    this.isExpirationDaysLoading = true;
    this.expirationDateList = [];
    this.combosStore
      .loadExpirationDays(+FINANCIAL_PRODUCT_AUTO)
      .then(
        (expirationDaysList) => {
          this.expirationDateList = expirationDaysList;

          //first day by default(ESPSCFWMTS-5245)
          if (this.request?.expirationDay) {
            this.requestDataAutosForm.controls.expirationDay.setValue(this.request.expirationDay);
          } else if (this.requestDataAutosForm.controls.expirationDay.value) {
            this.requestDataAutosForm.controls.expirationDay.setValue(
              this.requestDataAutosForm.controls.expirationDay.value
            );
          } else this.requestDataAutosForm.controls.expirationDay.setValue(expirationDaysList[0].id);
        },

        (error) => console.error(error)
      )
      .finally(() => {
        this.isExpirationDaysLoading = false;
        this.changeLoadingState();
      });
  }

  onCommercialProductSelection() {
    this.tariffsList = [];
    this.formPaymentList = [];

    this.requestDataAutosForm.controls.tariffs.reset();
    this.requestDataAutosForm.controls.formPayment.reset();
    this.changeValueForm();

    this.getTariffs();
    this.getFormPayment();
  }

  onTypeVehicleSelection() {
    this.tariffsList = [];
    this.brandList = [];
    this.modelList = [];
    this.versionList = [];
    this.fuelTypeList = [];
    this.requestDataAutosForm.controls.antCar.reset();
    this.checkAntYearActualDate();
    this.antCarValidation();
    this.requestDataAutosForm.controls.tariffs.reset();
    this.getTariffs();
    this.changeValueForm();

    if (this.requestDataAutosForm.controls.antCar.errors === null) {
      this.requestDataAutosForm.controls.brand.reset();
      this.requestDataAutosForm.controls.model.reset();
      this.requestDataAutosForm.controls.version.reset();
      this.getBrand();
      this.getModel();
    }
  }

  onAntYearSelection() {
    this.brandList = [];
    this.modelList = [];
    this.versionList = [];
    this.fuelTypeList = [];
    this.changeValueForm();
    this.antCarValidation();
    if (this.requestDataAutosForm.controls.antCar.errors === null) {
      this.requestDataAutosForm.controls.brand.reset();
      this.requestDataAutosForm.controls.model.reset();
      this.requestDataAutosForm.controls.version.reset();
      this.getBrand();
      this.getModel();
      this.getVersion();
    }
  }

  onBrandSelection() {
    this.modelList = [];
    this.versionList = [];
    this.fuelTypeList = [];
    this.requestDataAutosForm.controls.model.reset();
    this.requestDataAutosForm.controls.version.reset();
    this.changeValueForm();
    this.getModel();
    this.getVersion();
  }

  onModelSelection() {
    this.versionList = [];
    this.fuelTypeList = [];
    this.changeValueForm();
    this.getVersion();
  }

  getFormPayment() {
    if (this.requestDataAutosForm.controls.commercialProduct.value) {
      console.log(this.requestDataAutosForm.controls.commercialProduct.value);
      this.getVideoSelfingDigital({
        establishment: this.requestStore.listaFormulariosAutos[POINT_OF_SALE].controls.establishment.value?.slice(
          0,
          -1
        ),
        financialProduct: this.requestDataAutosForm.controls.commercialProduct.value?.slice(0, 2),
      });
    }

    let commercialProduct: string = this.requestDataAutosForm.controls.commercialProduct?.value;
    if (commercialProduct) {
      this.isFormPaymentLoading = true;
      this.changeLoadingState();
      this.combosStore
        .loadFormPayment('20', commercialProduct)
        .then(
          (data) => {
            this.formPaymentList = data;
            if (this.requestDataAutosForm.controls.formPayment.value) {
              this.requestDataAutosForm.controls.formPayment.setValue(
                this.requestDataAutosForm.controls.formPayment.value
              );
            } else {
              this.requestDataAutosForm.controls.formPayment.setValue(this.formPaymentList[0].id);
            }
          },
          (error) => {
            console.error(error);
          }
        )
        .finally(() => {
          this.isFormPaymentLoading = false;
          this.changeLoadingState();
        });
    }
  }

  getTariffs() {
    let commercialProduct: string = this.requestDataAutosForm.controls.commercialProduct?.value;
    let typeVehicle: string = this.requestDataAutosForm.controls.vehicleType?.value;
    if (this.establishment && commercialProduct && typeVehicle) {
      if (!this.isProductVehicleLoading) {
        this.isTariffLoading = true;
        this.changeLoadingState();
      }
      this.combosStore
        .loadComboTariffs(this.establishment, commercialProduct, typeVehicle)
        .then(
          (data) => {
            this.tariffsList = data;
            //seteado del primer valor del combo
            if (this.tariffsList.length === 1) {
              this.requestDataAutosForm.controls.tariffs.setValue(this.tariffsList[0].codigo);
            }
            if (this.mode !== REQUEST_MODE_NEW) {
              this.requestDataAutosForm.controls.tariffs.setValue(this.request.tariffSelected);
            }
          },
          (error) => {
            this.tariffsList = [];
            console.log(error);
          }
        )
        .finally(() => {
          if (!this.isProductVehicleLoading) {
            this.isTariffLoading = false;
            this.changeLoadingState();
          }
        });
    } else {
      this.isTariffLoading = false;
      this.changeLoadingState();
    }
  }

  getBrand() {
    const antYear: string = this.requestDataAutosForm.controls.antCar?.value;
    // TODO: REVISAR PORQUE VIENE LA FECHA A 0000
    if (antYear && this.requestDataAutosForm.controls.antCar.value != 'Invalid Date') {
      this.isBrandLoading = true;
      this.changeLoadingState();
      this.combosAutosStore
        .loadBrand(this.datePipe.transform(this.requestDataAutosForm.controls.antCar.value, 'yyyy'))
        .then(
          (data) => {
            this.brandList = data;
            //seteado del primer valor del combo
            if (this.brandList.length === 1) {
              this.requestDataAutosForm.controls.brand.setValue(this.brandList[0].id);
            }
            if (this.mode !== REQUEST_MODE_NEW) {
              this.requestDataAutosForm.controls.brand.setValue(this.request.brandVehicle);
            }
          },
          (error) => console.error(error)
        )
        .finally(() => {
          this.isBrandLoading = false;
          this.changeLoadingState();
        });
    } else {
      this.isBrandLoading = false;
      this.changeLoadingState();
    }
  }

  getModel() {
    const antYear: string = this.requestDataAutosForm.controls.antCar?.value;
    const brand: string = this.requestDataAutosForm.controls.brand?.value;
    if (antYear && brand && this.requestDataAutosForm.controls.antCar.value != 'Invalid Date') {
      this.isModelLoading = true;
      this.changeLoadingState();
      this.combosAutosStore
        .loadModel(this.datePipe.transform(this.requestDataAutosForm.controls.antCar.value, 'yyyy'), brand)
        .then(
          (data) => {
            this.modelList = data;
            //seteado del primer valor del combo
            if (this.modelList.length === 1) {
              this.requestDataAutosForm.controls.model.setValue(this.modelList[0].id);
              // Search Version.
              this.getVersion();
            }

            if (this.mode !== REQUEST_MODE_NEW) {
              this.requestDataAutosForm.controls.model.setValue(this.request.model);
            }
          },
          (error) => {
            console.error(error);
          }
        )
        .finally(() => {
          this.isModelLoading = false;
          this.changeLoadingState();
        });
    } else {
      this.isModelLoading = false;
      this.changeLoadingState();
    }
  }

  getVersion() {
    const model: string = this.requestDataAutosForm.controls.model?.value;
    const antYear: string = this.requestDataAutosForm.controls.antCar?.value;
    const brand: string = this.requestDataAutosForm.controls.brand?.value;
    if (model && antYear && brand && this.requestDataAutosForm.controls.antCar.value != 'Invalid Date') {
      this.isVersionLoading = true;
      this.changeLoadingState();
      this.combosAutosStore
        .loadVersion(model, this.datePipe.transform(this.requestDataAutosForm.controls.antCar.value, 'yyyy'), brand)
        .then(
          (data) => {
            this.versionList = data;
            //seteado del primer valor del combo
            if (this.versionList.length === 1) {
              this.requestDataAutosForm.controls.version.setValue(this.versionList[0].id);
              // Search Tariffs.
              this.getTariffs();
              this.onVersionSelection();
            }
            if (this.mode !== REQUEST_MODE_NEW) {
              this.requestDataAutosForm.controls.version.setValue(this.request.version);
            }
          },
          (error) => {
            console.error(error);
          }
        )
        .finally(() => {
          this.isVersionLoading = false;
          this.changeLoadingState();
        });
    } else {
      this.isVersionLoading = false;
      this.changeLoadingState();
    }
  }

  calculateStart() {
    this.changeValueForm();
    let priceVehicle = this.requestDataAutosForm.controls.priceVehicle;
    let requestedAmount = this.requestDataAutosForm.controls.requestedAmount;
    if (priceVehicle.value !== '' && requestedAmount.value !== '') {
      if (priceVehicle.dirty && requestedAmount.dirty) {
        let priceVehiclePrice = parseFloat(priceVehicle.value.toString().replaceAll('.', '').replace(',', '.'));
        let requestedAmountPrice = parseFloat(requestedAmount.value.toString().replaceAll('.', '').replace(',', '.'));

        if (requestedAmountPrice <= priceVehiclePrice) {
          let startTotal = priceVehiclePrice - requestedAmountPrice;

          const result = this.customValidators.transformAmount(startTotal.toString().replace('.', ','));

          this.requestDataAutosForm.controls.start.setValue(result);
          requestedAmount.setErrors(null);
          priceVehicle.setErrors(null);
        }
      } else {
        requestedAmount.setErrors(null);
        priceVehicle.setErrors(null);
      }
    } else {
      this.requestDataAutosForm.controls.start.setValue('');
      if (requestedAmount.value == '')
        setTimeout(() => this.requestDataAutosForm.controls.requestedAmount.setErrors({ required: true }));
      if (priceVehicle.value == '')
        setTimeout(() => this.requestDataAutosForm.controls.priceVehicle.setErrors({ required: true }));
    }
  }

  calculate(clickButton?: boolean) {
    this.changeValue.emit(false);
    let invalid: number = 0;
    Object.keys(this.requestStore.listaFormulariosAutos[REQUEST_DATA]?.controls).forEach((key) => {
      const control = this.requestStore.listaFormulariosAutos[REQUEST_DATA].controls[key];
      if (key !== 'quota' && key !== 'insurance' && key !== 'firstMonth') {
        if (
          (control.value === null || control.value === '') &&
          key !== 'numRack' &&
          key !== 'carRegistration' &&
          key !== 'fuelType'
        ) {
          invalid++;
          this.requestStore.listaFormulariosAutos[REQUEST_DATA].controls[key].setErrors({ showErrorCalculate: true });
        }
      }
    });
    if (invalid === 0) {
      const calculatorDTO: CalculatorAutosDTO = {
        user: this.credentials.credentials.username,
        establishment: this.establishment,
        comercialProduct: this.requestDataAutosForm.controls.commercialProduct.value,
        financialProduct: FINANCIAL_PRODUCT_AUTO,
        financial:
          this.requestDataAutosForm.controls.requestedAmount.value &&
          this.requestDataAutosForm.controls.requestedAmount.value.includes('€')
            ? this.requestDataAutosForm.controls.requestedAmount.value.slice(0, -1).trim()
            : this.requestDataAutosForm.controls.requestedAmount.value,
        installments: this.requestDataAutosForm.controls.term.value,
        sector: this.requestDataAutosForm.controls.vehicleType.value,
        paymentMethod: this.requestDataAutosForm.controls.formPayment.value,
        amount:
          this.requestDataAutosForm.controls.priceVehicle.value &&
          this.requestDataAutosForm.controls.priceVehicle.value.includes('€')
            ? this.requestDataAutosForm.controls.priceVehicle.value.slice(0, -1).trim()
            : this.requestDataAutosForm.controls.priceVehicle.value,
        codeTariff: this.requestDataAutosForm.controls.tariffs.value,
        deposit:
          this.requestDataAutosForm.controls.priceVehicle.value &&
          this.requestDataAutosForm.controls.start.value.includes('€')
            ? this.requestDataAutosForm.controls.start.value.slice(0, -1).trim()
            : this.requestDataAutosForm.controls.start.value,
        dayDeadline: this.requestDataAutosForm.controls.expirationDay.value,
        vendor: typeof this.vendor === 'string' ? this.vendor : this.vendor.id,
      };

      console.log('calculate dto: ', JSON.stringify(calculatorDTO));

      if (calculatorDTO.establishment) {
        this.sendDataFinance.emit({ request: calculatorDTO, export: false, click: clickButton });
      }
    } else {
      Object.keys(this.requestStore.listaFormulariosAutos[POINT_OF_SALE].controls).forEach((key) => {
        const control = this.requestStore.listaFormulariosAutos[POINT_OF_SALE].controls[key];
        if (
          (control.value === null || control.value === '') &&
          key !== 'version' &&
          key !== 'brand' &&
          key !== 'model'
        ) {
          this.requestStore.listaFormulariosAutos[POINT_OF_SALE].controls[key].setErrors({ showErrorCalculate: true });
        }
      });
    }
  }

  private getVideoSelfingDigital(digitalID: DigitalIdDTO) {
    if (this.mode !== REQUEST_MODE_VIEW) {
      this.requestsGetDataApi.getlVideoSelfingDigitalID(digitalID).subscribe(
        (data: DigitalIdResponseDTO) => {
          if (data?.digitalId) {
            this.videoSelfingIDInit = data.digitalId;
            if (this.mode == REQUEST_MODE_NEW) {
              this.requestStore.setVideoSelfingID(data.digitalId);
            }
            this.requestStore.setImporteMaxVideoSelfing(data.impMaxOpe11);
          } else {
            this.videoSelfingIDInit = 'N';
            this.requestStore.setVideoSelfingID('N');
            this.requestStore.setImporteMaxVideoSelfing(data.impMaxOpe11);
          }
        },
        (error) => {
          this.requestStore.setVideoSelfingID(null);
        }
      );
    }
  }

  updateCombos(form: FormGroup) {
    if (form) {
      Object.keys(this.requestDataAutosForm.controls).forEach((key) => {
        if (form.controls[key] !== null) {
          this.requestDataAutosForm.controls[key].setValue(form.controls[key].value);
        }
      });
    }
  }

  chosenMonthHandler(normalizedMonth: Moment, datepicker: MatDatepicker<Moment>) {
    const ctrlValue = this.requestDataAutosForm.controls.antCar.value;
    if (ctrlValue) {
      ctrlValue.month(normalizedMonth.month());
      this.requestDataAutosForm.controls.antCar.setValue(ctrlValue);
    } else {
      this.requestDataAutosForm.controls.antCar.setValue(
        moment('1/' + (normalizedMonth.month() + 1).toString() + '/' + normalizedMonth.year().toString(), 'DD-MM-YYYY')
      );
    }
    datepicker.close();
    this.onAntYearSelection();
  }

  chosenYearHandler(normalizedYear: Moment) {
    const ctrlValue = this.requestDataAutosForm.controls.antCar.value;
    if (ctrlValue) {
      ctrlValue.year(normalizedYear.year());
      this.requestDataAutosForm.controls.antCar.setValue(ctrlValue);
    } else {
      this.requestDataAutosForm.controls.antCar.setValue(
        moment('1/1/' + normalizedYear.year().toString(), 'DD-MM-YYYY')
      );
    }
  }

  numberOnly(event: any, element: any): boolean {
    const inputForm = typeof element === 'string' ? element : element?.getAttribute('formControlName');
    let value = this.requestDataAutosForm.controls[inputForm].value;

    return this.customValidators.numberOnly(event.which ? event.which : event.keyCode, value);
  }

  alphanumericOnly(event: any, element: any): boolean {
    const inputForm = typeof element === 'string' ? element : element?.getAttribute('formControlName');
    let value = this.requestDataAutosForm.controls[inputForm].value;

    return this.customValidators.alphanumericHyphenBackslash(event.which ? event.which : event.keyCode, value);
  }

  alphanumericAndSpecialCharacters(value: any, element: any) {
    const inputForm = typeof element === 'string' ? element : element?.getAttribute('formControlName');
    let inputValue = typeof value === 'string' ? value : value?.target.value;
    this.requestDataAutosForm.controls[inputForm].setValue(
      this.customValidators.validateAlphanumericAndSpecialChars(inputValue)
    );
  }
  transformAmount(value: any, element: any) {
    const inputForm = typeof element === 'string' ? element : element?.getAttribute('formControlName');
    let inputValue = typeof value === 'string' ? value : value?.target.value;
    // video-selfing
    if (inputForm == 'requestedAmount') {
      if (this.importeMaxVideoSelfing && inputValue) {
        let requestAmount = inputValue.replaceAll('.', '').replace(',', '.');
        if (requestAmount > this.importeMaxVideoSelfing) {
          this.requestStore.setVideoSelfingID('IMAX');
        } else {
          this.requestStore.setVideoSelfingID(this.videoSelfingIDInit);
        }
      }
    }

    if (inputValue.slice(-1) == '€') {
      //Si value entra formateado, quitamos formateo
      inputValue = inputValue.replace(/\ /g, '');
      inputValue = inputValue.replace(/\€/g, '');
      inputValue = inputValue.replace(/\./g, '');
    }
    this.requestDataAutosForm.controls[inputForm].setValue(this.customValidators.transformAmount(inputValue));
  }

  setValuesToForm() {
    this.requestDataAutosForm.controls.commercialProduct.setValue(this.request.commercialProduct);
    this.requestDataAutosForm.controls.vehicleType.setValue(this.request.typeVehicle);
    // if (this.mode === REQUEST_MODE_VIEW) {
    //   //AÑADIR
    //   this.brandList = [{ id: '0', value: this.request.brandVehicle }];
    //   this.modelList = [{ id: '0', value: this.request.model }];
    //   this.versionList = [{ id: '0', value: this.request.version }];
    //   this.requestDataAutosForm.controls.brand.setValue(this.brandList[0].id);
    //   this.requestDataAutosForm.controls.model.setValue(this.modelList[0].id);
    //   this.requestDataAutosForm.controls.version.setValue(this.versionList[0].id);
    // } else {
    this.requestDataAutosForm.controls.brand.setValue(this.request.brandVehicle);
    this.requestDataAutosForm.controls.model.setValue(this.request.model);
    this.requestDataAutosForm.controls.version.setValue(this.request.version);
    // }
    this.requestDataAutosForm.controls.numRack.setValue(this.request.numRack);
    this.requestDataAutosForm.controls.antCar.setValue(
      new Date(this.request.antCarYear + '/' + this.request.antCarMonth + '/01')
    ); //antCarMonth+antCarYear
    this.requestDataAutosForm.controls.carRegistration.setValue(this.request.carRegistration);
    this.requestDataAutosForm.controls.priceVehicle.setValue(this.request.amount + ' €');
    this.requestDataAutosForm.controls.requestedAmount.setValue(this.request.netPurchaseAmount + ' €');
    this.requestDataAutosForm.controls.start.setValue(this.request.entry + ' €');
    this.requestDataAutosForm.controls.term.setValue(this.request.numPlaz);
    this.requestDataAutosForm.controls.expirationDay.setValue(this.request.expirationDay);
    this.requestDataAutosForm.controls.firstMonth.setValue(this.request.expirationDayName);
    this.requestDataAutosForm.controls.tariffs.setValue(this.request.tariffSelected);
    this.requestDataAutosForm.controls.formPayment.setValue(this.request.formPayment);
    this.requestDataAutosForm.controls.quota.setValue(this.request.quota);
    this.requestDataAutosForm.controls.insurance.setValue(
      this.request.codpac === '99'
        ? this.translateService.instant('requestFinance.noProteccion')
        : this.request.descCodPac
    );
    this.requestDataAutosForm.controls.fuelType.setValue(this.request?.fuelType);
    this.vendor = this.request.vendor;
  }

  changeLoadingState() {
    if (
      !this.isExpirationDaysLoading &&
      !this.isProductVehicleLoading &&
      !this.isTariffLoading &&
      !this.isFormPaymentLoading &&
      !this.isBrandLoading &&
      !this.isModelLoading &&
      !this.isVersionLoading
    ) {
      this.isFinishedLoading.emit({ formID: REQUEST_DATA, value: true });
      this.firstloadEdit = false;
    } else {
      this.isFinishedLoading.emit({ formID: REQUEST_DATA, value: false });
    }
  }

  private antCarValidation() {
    if (this.requestDataAutosForm.controls.vehicleType?.value) {
      const vehicleType = this.typeVehicleList.find(
        (vehicleType) => vehicleType.sector === this.requestDataAutosForm.controls.vehicleType.value
      );
      if (this.requestDataAutosForm.controls.antCar.hasValidator(this.validatorAntCar)) {
        this.requestDataAutosForm.controls.antCar.removeValidators(this.validatorAntCar);
      }
      this.validatorAntCar = this.customValidators.isAntCarValid(vehicleType);
      this.requestDataAutosForm.controls.antCar.addValidators(this.validatorAntCar);
      if (this.requestDataAutosForm.controls.antCar?.value) {
        this.requestDataAutosForm.controls.antCar.updateValueAndValidity({ onlySelf: true });
      }
    }
  }

  private checkAntYearActualDate() {
    new Promise<void>((resolve) => {
      const antCarControl = this.requestDataAutosForm.controls.antCar;
      const vehicleType = this.requestDataAutosForm.controls.vehicleType.value;
      if (vehicleType) {
        const ganvam = this.typeVehicleList.find((type) => type.sector === vehicleType)?.ganvamRelation;
        if (ganvam === 'N') antCarControl.setValue(moment());
      }
      resolve();
    }).catch((error) => console.error('An unexpected error in checkAntYearActualDate method has occured', error));
  }

  private loadCombosFromCalculator() {
    this.updateCombos(this.requestStore.listaFormulariosAutos[REQUEST_DATA]);
    this.getBrand();
    this.getModel();
    this.getVersion();
    this.getTariffs();
    this.getFormPayment();
    this.getFuelType();
    this.calculate();
  }

  private isModeDifferentFromNew() {
    return this.mode && this.mode !== REQUEST_MODE_NEW;
  }

  getFuelType = () => {
    const fuelTypeRequest: VehicleTypeFuel = {
      brand: this.requestDataAutosForm.controls.brand.value,
      model: this.requestDataAutosForm.controls.model.value,
      version: this.requestDataAutosForm.controls.version.value,
    };
    this.fuelTypeList = [{ id: '', value: this.translateService.instant('requestDataAutos.fuelType.empty') }];
    if (this.mode !== REQUEST_MODE_VIEW || (this.mode === REQUEST_MODE_VIEW && this.request?.fuelType)) {
      this.combosStore
        .getFuelType(fuelTypeRequest)
        .then((data) => {
          if (Array.isArray(data) && data?.length > 0) {
            const fuelTypeList = [...data.filter((fuelType) => Object.keys(fuelType).length > 0)];
            if (fuelTypeList?.length > 0) {
              this.fuelTypeList = fuelTypeList;
            }
          }
        })
        .finally(() => {
          if (this.fuelTypeList.length === 1) {
            this.requestDataAutosForm.controls.fuelType.setValue(this.fuelTypeList[0].id);
          }
        });
    } else {
      this.requestDataAutosForm.controls.fuelType.setValue(this.fuelTypeList[0].id);
    }
  };

  private reset = () => {
    this.commercialProductList = [];
    this.tariffsList = [];
    this.typeVehicleList = [];
    this.brandList = [];
    this.modelList = [];
    this.versionList = [];
    this.formPaymentList = [];
    this.fuelTypeList = [];
    this.requestDataAutosForm?.reset();
  };

  onVersionSelection() {
    this.changeValueForm();
    if (
      this.credentials.credentials.userType == 'I' ||
      this.credentials.credentials.userType == 'X' ||
      this.credentials.credentials.userType == 'O'
    ) {
      this.versionList.forEach((version: any) => {
        if (version.value == this.requestDataAutosForm.controls.version?.value) {
          if (!version.price.toString().includes('.')) {
            version.price = version.price.toFixed(Math.max(((version.price + '').split('.')[1] || '').length, 2));
          }
          this.reference = version.price;
        }
      });
    }
    this.getFuelType();
  }

  private carRegistrationFormControl(vehicleStatus: string): FormControl {
    const validators: ValidatorFn[] = [this.customValidators.isCarRegistrationValid];
    if (this.vehicleIsUsed(vehicleStatus)) {
      validators.push(Validators.required);
    }
    return new FormControl({ value: this.request.carRegistration, disabled: false }, validators);
  }

  private vehicleIsUsed(vehicleStatus: string): boolean {
    return vehicleStatus === VEHICLE_USED;
  }

  ngAfterContentChecked() {
    //PE_725 Fenix
    if (this.mode === REQUEST_MODE_EDIT && this.request !== null && this.request.fieldsDisable !== null) {
      this.fieldsDisabled = this.request.fieldsDisable;
      this.disableFieldsByCore();
    }
  }

  changeValueForm() {
    if (!this.firstloadEdit) {
      this.changeValue.emit(true);
    } else {
      this.changeValue.emit(false);
    }
  }

  private disableFieldsByCore() {
    if (this.fieldsDisabled !== null && this.fieldsDisabled !== undefined) {
      const form = this.requestDataAutosForm;
      this.fieldsDisabled.forEach((field) => {
        const toDisable = form.get(field.campoName);
        if (toDisable !== null && toDisable !== undefined) {
          toDisable.disable();
        }
      });
    }
  }
}
